export default {
    add_new_field_section: "Neue Feld Sektion anlegen",
    field_section: "Feld Bereich"
  }